import Header from "@/components/landing/Header";
import HeroSection from "@/components/landing/HeroSection";
import ClientSection from "@/components/landing/ClientSection";
import ChallengeSection from "@/components/landing/ChallengeSection";
import SolutionSection from "@/components/landing/SolutionSection";
import ResultsSection from "@/components/landing/ResultsSection";
import VisionSection from "@/components/landing/VisionSection";
import CTASection from "@/components/landing/CTASection";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ClientSection />
        <ChallengeSection />
        <SolutionSection />
        <ResultsSection />
        <VisionSection />
        <CTASection />
      </main>
    </div>
  );
}
